import frappe from './frappe';

export async function fetchProductStock(itemCode) {
  try {
    const { data } = await frappe.get(
      `/api/resource/Bin?filters=[["item_code","=","${itemCode}"]]&fields=["warehouse","actual_qty"]&limit=50`
    );
    return data.data.map(row => ({
      warehouse: row.warehouse,
      real: row.actual_qty,
    }));
  } catch (error) {
    if (error.response?.status === 404) return [];
    console.error('Error fetching product stock:', error.message);
    return [];
  }
}

export async function fetchStockWithLabels(itemCode) {
  try {
    const stock = await fetchProductStock(itemCode);
    return stock.map(entry => ({
      label: entry.warehouse.replace(' - VE', ''),
      real: entry.real,
    }));
  } catch (error) {
    console.error('Error combining stock:', error.message);
    return null;
  }
}

// Trae el stock de TODOS los items en una sola llamada (evita N+1 requests
// al cargar el catálogo completo) y lo agrupa por item_code.
export async function fetchAllStock() {
  try {
    const { data } = await frappe.get(
      `/api/resource/Bin?fields=["item_code","warehouse","actual_qty"]&limit=100000`
    );
    const stockByItem = {};
    data.data.forEach(row => {
      if (!stockByItem[row.item_code]) stockByItem[row.item_code] = [];
      stockByItem[row.item_code].push({
        label: row.warehouse.replace(' - VE', ''),
        real: row.actual_qty,
      });
    });
    return stockByItem;
  } catch (error) {
    console.error('Error fetching all stock:', error.message);
    return {};
  }
}
